export default {
    addTocart(item) {
        let cart = this.getCart()
        let found = false

        for (const element of cart) {

            if (item.id === element.id && item.simpleProduct) {
                element.cantidad = element.cantidad + item.cantidad
                found = true
                break
            }

            if (item.id === element.id && !item.simpleProduct) {
                if (item.variants?.length === element.variants?.length) {
                    let allFound = true
                    
                    for (const elementVariant of element.variants) {
                        const foundVariant = item.variants.find(
                            itemVariant => itemVariant.id === elementVariant.id  
                        )
                        
                        if (!foundVariant) {
                            allFound = false
                            break
                        }
                    }
                    
                    if (allFound) {
                        element.cantidad = element.cantidad + item.cantidad
                        found = true
                        break
                    }
                }
            }
        }

        if (!found) {
            cart.push(item)
        }

        return this.saveCart(cart)
    },
    
    saveCart(cart) {
        sessionStorage.setItem('cart', JSON.stringify(cart))
        return cart
    },

    removeItem(index) {
        let cart = this.getCart()
        if (index >= 0 && index < cart.length) {
            cart.splice(index, 1)
            return this.saveCart(cart)
        }
        return cart
    },

    getCart() {
        const cart = sessionStorage.getItem('cart')
        if (!cart) {
            return this.saveCart([])
        }

        const parse = JSON.parse(cart)
        if (!Array.isArray(parse)) {
            return this.saveCart([])
        }

        return parse
    }
}